import React from 'react';
import { Modal, useT } from '@repo/common';

const BookingConflictModal = ({ isOpen, onClose, onContinue }) => {
  const t = useT();
  const handleCancel = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    onClose && onClose();
  };

  const handleContinue = () => {
    onContinue && onContinue();
    onClose && onClose();
  };

  // Modal 컴포넌트의 linkHref는 일반 <a> 태그를 사용하므로,
  // React Router의 navigate를 사용하려면 subText에 링크를 포함시키고
  // 클릭 이벤트를 처리할 수 없습니다.
  // 대신 linkHref를 사용하여 페이지 이동을 처리합니다.
  // (페이지 전체 리로드가 발생할 수 있지만, Modal 컴포넌트의 제약사항입니다)

  return (
    <Modal
      isOpen={isOpen}
      type='default'
      title={t(
        'You already have a booking for this workshop',
        '이미 이 워크숍에 대한 예약이 있습니다',
      )}
      subText={t(
        'You already have another booking or waitlist entry. If this is a date change, please cancel the other one.',
        '이미 다른 예약 또는 대기 신청이 있습니다. 날짜 변경이라면 기존 건을 먼저 취소해 주세요.',
      )}
      linkText={t('View my bookings', '내 예약 보기')}
      linkHref='/community/kpathport/booking'
      onClickLeftBtn={handleCancel}
      onClickRightBtn={handleContinue}
      leftButtonLabel={t('cancel', '취소')}
      rightButtonLabel={t('Continue', '계속하기')}
      buttonSize='xl'
      leftHideIcon={true}
      rightHideIcon={true}
    />
  );
};

export default BookingConflictModal;
